import { render, staticRenderFns } from "./_instructor.vue?vue&type=template&id=c6b89350&"
import script from "./_instructor.vue?vue&type=script&lang=js&"
export * from "./_instructor.vue?vue&type=script&lang=js&"
import style0 from "./_instructor.vue?vue&type=style&index=0&id=c6b89350&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports